import { convertToLocalTime } from '@/utils';


const LogInfo = ({ createdAt, updatedAt }) => (
  <div className='bg-white p-0 mt-8'>
    <div className='flex items-start px-8 pt-8 pb-0 gap-3 rounded-t'>
      <p className='font-bold text-lg'>Log Info</p>
    </div>
    <div className='flex flex-col items-start p-8 gap-6 rounded-b'>
        <div className='flex justify-between w-full py-2'>
            <p className="text-sm text-grey-dark">Created at</p>
            <div className='flex flex-col'>
            <p className="font-medium text-sm text-right text-grey-dark">{`${new Date(convertToLocalTime(Number(createdAt))).toLocaleString('id-ID', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}`}</p>
            </div>
        </div>
        <div className='flex justify-between w-full py-2'>
            <p className="text-sm text-grey-dark">Updated at</p>
            <div className='flex flex-col'>
            <p className="font-medium text-sm text-right text-grey-dark">{`${new Date(convertToLocalTime(Number(updatedAt))).toLocaleString('id-ID', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}`}</p>
            </div>
        </div>
    </div>
  </div>
)
export default LogInfo
